import { render, staticRenderFns } from "./MatrixComposableQuestion.vue?vue&type=template&id=6f1837fc&scoped=true"
import script from "./MatrixComposableQuestion.vue?vue&type=script&lang=js"
export * from "./MatrixComposableQuestion.vue?vue&type=script&lang=js"
import style0 from "./MatrixComposableQuestion.vue?vue&type=style&index=0&id=6f1837fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1837fc",
  null
  
)

export default component.exports